import React from 'react';
import { Frame, Icon, SageClassnames, SageTokens } from '@kajabi/sage-react';
import PropTypes from 'prop-types';

import { MockItem } from './MockItem';

export const Community = ({ breakpoints, hideOrExpandSection }) => {
  return (
    <Frame gap={Frame.GAPS.NONE}>
      <Frame
        direction={Frame.DIRECTIONS.HORIZONTAL}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : 'MD']}
      >
        <Frame align={Frame.ALIGNMENTS.CENTER_LEFT} style={{ height: '100%' }}>
          <MockItem
            color={SageTokens.COLOR_PALETTE.YELLOW_300}
            height={12}
            width={87}
          />
        </Frame>
        <Frame
          align={Frame.ALIGNMENTS.CENTER_RIGHT}
          direction={
            Frame.DIRECTIONS[breakpoints.sm ? 'VERTICAL' : 'HORIZONTAL']
          }
          gap={Frame.GAPS[breakpoints.sm ? '2XS' : 'MD']}
        >
          {Array(breakpoints.sm ? 3 : 5)
            .fill()
            .map((_, index) => (
              <MockItem
                color={SageTokens.COLOR_PALETTE.YELLOW_300}
                height={8}
                key={`community-page-header-${index}`}
              />
            ))}
        </Frame>
      </Frame>
      <Frame
        direction={Frame.DIRECTIONS.HORIZONTAL}
        style={{
          borderTop: breakpoints.sm ? undefined : `1px solid ${SageTokens.COLOR_PALETTE.GREY_300}`,
        }}
      >
        {breakpoints.sm || <Frame
          align={Frame.ALIGNMENTS.CENTER_LEFT}
          className={hideOrExpandSection(1)}
          background="#FDF1C3"
          padding={Frame.PADDINGS.MD}
          style={{ height: '100%', minWidth: 250}}
          width={Frame.WIDTHS.HUG}
        >
          <MockItem
            color="#EBA800"
            height={12}
            width={74}
          />
          <MockItem
            color="#EAC343"
            height={12}
            width={168}
          />
          <Frame
            background={SageTokens.COLOR_PALETTE.WHITE}
            borderRadius={Frame.BORDER_RADII.MD}
            padding={Frame.PADDINGS.SM}
          >
            <MockItem
              color="#FFBF1F"
              height={8}
              width={80}
            />
            {Array(4)
            .fill()
            .map((_, index) => (
              <Frame
                align={Frame.ALIGNMENTS.CENTER_SPREAD}
                direction={Frame.DIRECTIONS.HORIZONTAL}
                gap={Frame.GAPS.XS}
                key={`community-page-left-nav-row-${index}`}
              >
                <Frame width={Frame.WIDTHS.HUG}>
                  <Icon
                    color={Icon.COLORS.YELLOW_300}
                    icon={Icon.ICONS[index === 3 ? 'BLOG' : 'COMMENT']}
                  />
                </Frame>
                <Frame
                  align={Frame.ALIGNMENTS.CENTER_SPREAD}
                  direction={Frame.DIRECTIONS.HORIZONTAL}
                >
                  <MockItem
                    color="#FFBF1F"
                    height={8}
                    width="48%"
                  />
                  <MockItem
                    color="#FFBF1F"
                    height={8}
                    width="48%"
                  />
                </Frame>
              </Frame>
            ))}
          </Frame>
        </Frame>
        }
        <Frame
          className={hideOrExpandSection(1)}
          gap={Frame.GAPS.LG}
          style={{padding: breakpoints.sm ? 16 : "24px 64px"}}
        >
          <MockItem
            color="#FFC42E"
            height={12}
            width={150}
          />
          {
            Array(breakpoints.sm ? 2 : 3)
            .fill()
            .map((_, index) => (
              <Frame
                align={Frame.ALIGNMENTS[index & 1 ? 'TOP_RIGHT' : 'TOP_LEFT']}
                key={`community-page-section-${index}`}
                gap={Frame.GAPS.SM}
              >
                <Frame
                  align={Frame.ALIGNMENTS[index & 1 ? 'CENTER_RIGHT' : 'CENTER_LEFT']}
                  className={hideOrExpandSection(1)}
                  direction={Frame.DIRECTIONS.HORIZONTAL}
                  gap={Frame.GAPS.XS}
                >
                  <MockItem
                    borderRadius={20}
                    color="#FFC42E"
                    height={20}
                    width={20}
                  />
                  <MockItem
                    color="#FFC42E"
                    height={12}
                    width={150}
                  />
                </Frame>
                <Frame
                  background="#FDF1C3"
                  className={hideOrExpandSection(2)}
                  borderRadius={Frame.BORDER_RADII.MD}
                  style={{height: 154}}
                />
                <MockItem
                  className={hideOrExpandSection(2)}
                  color="#FDF1C3"
                  height={8}
                  width="75%"
                />
                <MockItem
                  className={hideOrExpandSection(2)}
                  color="#FDF1C3"
                  height={8}
                  width="25%"
                />
              </Frame>
            ))
          }
        </Frame>
      </Frame>
    </Frame>
  );
};

Community.propTypes = {
  breakpoints: PropTypes.shape({}).isRequired,
  hideOrExpandSection: PropTypes.func.isRequired,
};
